<template>
  <div class="row q-pt-xs">
    <div class="col-4 q-pb-md">
      <q-btn
          flat
          color="info"
          icon="remove"
          class="fit q-btn--no-hover"
          size="lg"
          :disable="!getOptions.allowNegative && value <= 0"
          @click="handleDecrease"
      />
    </div>

    <div class="col-4">
      <q-input
          standout="bg-teal text-white"
          type="number"
          class="q-mx-md full-width text-center q-input--center"
          :model-value="value"
          denses
          @update:model-value="handleAmount"
          @focus="onFocus"
          @blur="onFocusOut"
      />

      <div class="text-caption text-weight-bold text-center text-grey-7 q-mt-xs">
        {{ `${$t('Max')} ${data.max} ${$t('at once')}` }}
      </div>
    </div>

    <div class="col-4 q-pb-md">
      <q-btn
          flat
          color="info"
          icon="add"
          size="lg"
          class="fit q-btn--no-hover"
          :disable="!getOptions.allowNoLimit && value >= data.max"
          @click="handleIncrease"
      />
    </div>

    <div class="col-12 text-center q-pa-sm">
      <q-btn
          no-caps
          unelevated
          style="min-width: 100px;"
          :class="{ 'q-mr-lg': getOptions.allowAdditionalAction }"
          :disable="!getOptions.allowNegative && value <= 0"
          :color="value === 0 ? 'grey' : 'teal'"
          :outline="value === 0"
          :label="$t(getOptions.label || 'Adjust')"
          @click="handleSubmit"
      />

      <q-btn
          no-caps
          unelevated
          style="min-width: 100px;"
          class="q-ml-lg"
          v-if="getOptions.allowAdditionalAction"
          :disable="disableAdditionalAction && this.value <= 0"
          :color="additionalActionColor"
          :outline="isOutlined"
          :label="$t(getOptions.allowAdditionalAction.label)"
          @click="handleAdditionalAction"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CounterSection',
  props: {
    data: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    options: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    disableAdditionalAction: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      value: 0
    }
  },
  computed: {
    getOptions () {
      return this.options
    },
    isOutlined () {
      if (this.disableAdditionalAction && this.value <= 0) {
        return true
      }
      if (this.value === 0) {
        return true
      }
      return false
    },
    additionalActionColor () {
      if (this.disableAdditionalAction && this.value <= 0) {
        return 'grey'
      }
      if (this.value === 0) {
        return 'grey'
      }

      return 'teal'
    }
  },
  methods: {
    handleDecrease () {
      this.value -= 1
    },
    handleIncrease () {
      this.value += 1
    },
    handleAmount (value) {
      this.value = value

      if (this.value > this.data.max) {
        this.value = this.data.max
      } else if (!this.getOptions.allowNegative && this.value < 0) {
        this.value = 0
      }
    },
    handleSubmit () {
      this.$emit('click', { event: 'counter.submit', data: { value: this.value } })
      this.value = 0
    },
    handleAdditionalAction () {
      this.$emit('click', { event: 'counter.additional.submit', data: { value: this.value } })
      this.value = 0
    },
    onFocus () {
      this.$emit('click', { event: 'counter.focus' })
    },
    onFocusOut () {
      this.$emit('click', { event: 'counter.focusOut' })
    }
  }
}
</script>
